export const SOURCES = {
  metrics: 'metrics',
  params: 'params'
};
